export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';

export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';

export const DATA_DSDANGCHO = 'DATA_DSDANGCHO';
export const DATA_DSDANGCHO_SUCCESS = 'DATA_DSDANGCHO_SUCCESS';
export const DATA_DSDANGCHO_ERROR = 'DATA_DSDANGCHO_ERROR';

export const DATA_DSHOANTAT = 'DATA_DSHOANTAT';
export const DATA_DSHOANTAT_SUCCESS = 'DATA_DSHOANTAT_SUCCESS';
export const DATA_DSHOANTAT_ERROR = 'DATA_DSHOANTAT_ERROR';

export const DATA_CHITIETCLS = 'DATA_CHITIETCLS';
export const DATA_CHITIETCLS_SUCCESS = 'DATA_CHITIETCLS_SUCCESS';
export const DATA_CHITIETCLS_ERROR = 'DATA_CHITIETCLS_ERROR';

export const SAVE_DATA = 'SAVE_DATA';
export const SAVE_DATA_SUCCESS = 'SAVE_DATA_SUCCESS';
export const SAVE_DATA_ERROR = 'SAVE_DATA_ERROR';